<template>
  <div>
    <confirm ref="confirm"></confirm>
    <span id="demo22"></span>

    <form id="myForm" :action="actionlink()" method="post" target="_blank">
      <input id="inputsaveurl" type="hidden" name="saveurl">
      <input id="inputdata" type="hidden" name="data">
    </form>

    <v-select hide-details v-model="item" :items="items" item-text="ad" item-value="id" label="Pdf Şablon"
      return-object>
      <v-menu slot="append-outer" style="top: -12px" offset-y>
        <v-btn :style=GetMenuDisable color="info" small slot="activator"> {{ $t('Design-Menu') }} </v-btn>
        <v-card>
          <!--
                  <v-btn large flat color="primary" @click="clickMe"><v-icon left>mdi-target</v-icon>Click me</v-btn>
          -->
          <v-btn type="submit" small flat color="primary" @click="DesignShow($event)">Dizayn Yap</v-btn>
          <v-btn small flat color="primary" @click="dialogEkle=true">Dizay Ekle</v-btn>
          <v-btn small flat color="primary" @click="DizaynIndir()">Dizayn {{ $t('Download') }}</v-btn>
          <v-btn small flat color="warning" @click="$refs.inputUpload.click()">Dizayn Yükle</v-btn>
          <input v-show="false" ref="inputUpload" type="file" @change="DizaynYukle()">

          <v-btn small flat color="warning" @click="DizaynDelete()"> {{ $t('Delete-Design') }} </v-btn>

        </v-card>
      </v-menu>
    </v-select>

    <customdialog v-model="dialogEkle" maxWidth="400px" cardtextstyle="height: 160px;" :title="$t('Add-Design')">
      <slot name="dialogmain">
        <v-text-field hide-details :label="$t('Design-Name')" v-model="dizaynAdi"></v-text-field>
      </slot>
      <template slot="btn">
        <v-btn color="primary" flat @click="DizaynEkle()">{{$t("save_button")}}</v-btn>
      </template>
    </customdialog>


    <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
      :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
      {{ text1 }}
      <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
    </v-snackbar>


    <v-dialog v-model="pdfdialog" width="570px" height="850px">
      <div id="my-container">
        <iframe src="" height="810" width="550" type="application/pdf">
        </iframe>
      </div>
    </v-dialog>

  </div>
</template>

<script>
  import auth from "../../../../api/auth.js"
  import tool from "../tools";
  import customdialog from "@/components/app/coper/comp/customdialog.vue";
  import confirm from "@/components/app/coper/comp/confirm.vue";
  import helpers from "@/components/app/customcomp/helpers.js"

  export default {
    props: ["value", "dizayngrupadi", "objectname", "menudisable"],
    components: {
      customdialog,
      confirm
    },

    computed: {
      DizaynId: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit("input", newValue);
        }
      },

      item: {
        get: function () {
          return this.fitem;
        },
        set: function (newValue) {
          if (newValue != undefined && newValue.id != undefined && newValue.id > 0) {


            this.DizaynId = newValue.id.valueOf();
          }
          this.fitem = newValue;
        }
      },

      GetDizaynGrupAdi: {
        get: function () {
          var r = this.dizayngrupadi;
          return r;
        }
      },

      GetMenuDisable: {
        get: function () {

          if (this.menudisable == undefined) {
            return "";
          } else {
            return "display:none;";
          }

        }
      },

      GetObjectName: {
        get: function () {
          var r = this.objectname;
          return r;
        }
      }

    },
    watch: {
      DizaynId: function (id) {
        this.ItemBul(id)
      },

    },
    data() {
      return {
        items: [],
        fitem: {},
        dialogEkle: false,
        dialogEdit: false,
        pdfdialog: false,

        dizaynAdi: "",
        dizaynParametre: "",
        resolve: null,
        reject: null,
        //prm: {},
        Guid: "",
        saveurl: "",
        ilkYukleme: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',

      };
    },
    created: function () {
      this.sablonGetir();
    },
    methods: {

      actionlink() {
        return auth.REPORTBRO_URL + "/DesignShow"
      },

      ItemBul(id) {
        if (this.fitem == undefined || this.fitem.id != id) {
          var found = this.items.find(function (element) {
            return element.id == id;
          });

          if (found == undefined)
            this.item = {};
          else
            this.item = found;

        }
      },

      Print(val, dizaynId) {

        this.$forceUpdate();

        var SablonId = this.DizaynId;
        if (dizaynId !== undefined && dizaynId > 0) {
          SablonId = dizaynId;
        }

        var prm = {
          SablonId: SablonId,
          PrintObjectName: null, //this.GetObjectName, // "Controllers.ReportBro.InvoicePrint",
          IsTestData: false,
          Prm: val
        };

        this.Send2(prm);

        return new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });

      },
      DizaynEkle() {
        tool
          .api_post(this, "ReportBro/GetReportBroDesignInsert", {
            id: 0,
            ad: this.dizaynAdi,
            reportBroGrupAdi: this.GetDizaynGrupAdi,
            objectName: this.GetObjectName
          })
          .then(
            response => {
              this.items.push(response.body);
              this.item = response.body;
              this.dialogEkle = false;
            },
            response => {
              this.items = [];
              this.dialogEkle = false;
            }
          );
      },
      DizaynUpdate() {
        tool
          .api_post(this, "ReportBro/GetReportBroDesignUpdate", {
            id: this.item.id,
            reportBroGrupid: this.item.reportBroGrupId,
            ad: this.item.ad,
            design: this.dizaynParametre
          })
          .then(
            response => {
              this.dialogEdit = false;
            },
            response => {
              this.dialogEdit = false;
            }
          );
      },
      DizaynDelete() {
        this.$refs.confirm
          .open("Kayıt Sil", this.$t('Delete-the-records'), {
            color: "red",
            message: this.$t('approve-record-deletion')
          })
          .then(confirm => {
            if (confirm == true) {
              this.sil();
            }
          });
      },

      sil() {
        tool
          .api_post(this, "ReportBro/GetReportBroDesignDelete", {
            id: this.item.id,
            reportBroGrupid: this.item.reportBroGrupId,
            ad: this.item.ad,
            design: this.dizaynParametre
          })
          .then(
            response => {
              this.sablonGetir();
            },
            response => {}
          );
      },

      DizaynIndir() {

        tool.api_post_FileDownload(this, "ReportBro/ReportBroDesignDownload", {
          value: this.item.id,
        }).then(
          response => {

            var blob = new Blob([response.data], {
              type: 'application/json'
            });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = "ReportDesign.json";
            link.click();

          },
          response => {

          }
        );
      },

      DizaynYukle() {

        var file = this.$refs.inputUpload.files[0];

        this.submitFile(file);

      },

      submitFile(file) {
        let formData = new FormData();
        formData.append('file', file);


        formData.append('raporId', this.item.id)

        tool.api_file_post(this, "ReportBro/ReportBroDesignUpload", formData)
          .then(
            response => {
              this.$refs.inputUpload.value = '';
            },
            response => {

              this.$refs.inputUpload.value = '';
            }
          );

      },

      DesignShow(evt) {
        this.Guid = "";
        tool
          .api_post(this, "ReportBro/TableDesignRead", {
            value: this.item.id,
          })
          .then(
            response => {

              document.getElementById("inputsaveurl").value = auth.API_URL + "api/ReportBro/DesignSave?id=" + this.item
                .id + "&bearer=" + auth.getAuthHeader();
              document.getElementById("inputdata").value = response.body;
              evt.preventDefault();
              document.getElementById("myForm").submit();
            },
            response => {}
          );

      },
      Uygula() {
        tool
          .api_post(this, "ReportBro/GetReportBroGetDesign", {
            key: this.Guid,
          })
          .then(
            response => {
              this.dizaynParametre = response.body;
            },
            response => {}
          );
      },

      sablonGetir() {
        tool
          .api_post(this, "ReportBro/GetReportBroDesignGrupAll", {
            id: 0,
            ad: this.GetDizaynGrupAdi,
            objectName: this.GetObjectName
          })
          .then(
            response => {

              this.items = response.body;
              if ((this.ilkYukleme) && (this.DizaynId > 0)) {
                this.ItemBul(this.DizaynId);
              } else {
                if (this.items.length > 0) {
                  this.item = this.items[0];
                } else {
                  this.item = null;
                }
              }

              this.ilkYukleme = false;
            },
            response => {
              this.items = [];
            }
          );
      },

      Send(prm) {
        tool.api_post_FileDownload(this, "ReportBro/ReportBroPrintPdf", prm).then(
          response => {
            var blob = new Blob([response.data], {
              type: "application/pdf"
            });


            //var link = document.createElement("a");
            //link.href = window.URL.createObjectURL(blob);
            //link.download = "rapor.pdf";
            //link.click();

            //var url = URL.createObjectURL(blob);
            //var printWindow = window.open(url, '', 'width=800,height=500');
            //printWindow.print()

            var file = window.URL.createObjectURL(blob);
            document.querySelector("iframe").src = file;
            this.pdfdialog = true;

            this.resolve(true);
          },
          response => {
            this.resolve(false);
          }
        );
      },

      Send2(prm) {

        var result = {
          sonuc: false,
          mesaj: '',
        }

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.$http.post(auth.API_URL + 'api/ReportBro/ReportBroPrintPdf2', prm, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader(),
            'CariSirketNo': String(credentials.SirketKodu),
            'CoperSirketNo': String(credentials.CoperSirketNo)
          },
          responseType: "application/json"
        }).then((response) => {

          if (response.body.Status == true) {

            result.sonuc = true
            result.mesaj = 'sonuç başarılı'

            var dosya = helpers.base64ToArrayBuffer(response.body.data);
            var blob = new Blob([dosya], {
              type: "application/pdf"
            });
            var file1 = window.URL.createObjectURL(blob);
            document.querySelector("iframe").src = file1;
            this.pdfdialog = true;
            this.resolve(result);

          } else {
            result.sonuc = false
            result.mesaj = (response.body.ErrorList || []).join(" ");
            this.resolve(result);
          }

        }, (response) => {
          // Sunucunun gercek aciklamasi (CLAUDE.md: HataMesajiCoz). Onceden ErrorList[0] okunuyordu;
          // 429 duz metin, baglanti yok ya da istisnada govde ResponseBase olmadigi icin hata
          // firliyor ve Print'in Promise'i hic cozulmuyordu.
          result.sonuc = false
          result.mesaj = tool.HataMesajiCoz(response, this.$t.bind(this));
          this.resolve(result);
        })

      }
    }
  };
</script>